/* 🤖 this file was generated by svg-to-ts*/
export const icoTagFilled: {
  name: 'tag-filled';
  data: string;
} = {
  name: 'tag-filled',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 9a2 2 0 110-4 2 2 0 010 4zm14.41 2.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.11 0-2 .89-2 2v7c0 .55.22 1.05.59 1.41l8.99 9c.37.36.87.59 1.42.59.55 0 1.05-.23 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.56-.23-1.06-.59-1.42z" fill="#909090"/></svg>`
};
